import React from "react";
import { translate } from "react-polyglot";
import { Col, Input, Row } from "reactstrap";

interface ICustomInputProps {
  fieldName: string;
  isChecked: boolean;
  options: IOption[];
  checkedOption: string;
  handleValueChange: (value: string[]) => void;
}

interface IOption {
  label: string;
  value: string | number;
}

const CustomCheckbox = ({
  fieldName,
  options,
  t,
  handleValueChange,
  checkedOption
}: ICustomInputProps & TranslateProps) => {
  return (
    <React.Fragment>
      <label htmlFor={fieldName}>{t(`parameters.${fieldName}`)}</label>
      <Row>
        {options.map(option => {
          const { label, value } = option;
          const id = `${fieldName}${value}`;
          const colLengthCheck = options.length > 3 ? "col-12" : "";
          const colClass = "offset-1" + " " + colLengthCheck;

          return (
            <React.Fragment key={label}>
              <Col className={colClass}>
                <Input
                  type="checkbox"
                  name={fieldName}
                  id={id}
                  value={value}
                  checked={checkedOption === value}
                  onChange={e => handleValueChange([e.target.value])}
                />
                <label className="" htmlFor={id}>
                  {label}
                </label>
              </Col>
            </React.Fragment>
          );
        })}
      </Row>
    </React.Fragment>
  );
};

export default translate()(CustomCheckbox);
